import axios from 'axios'
import BaseRequest from './BaseRequest'

export default class CategoryRequest extends BaseRequest {
  getList(params) {
    return axios.get(`${this.baseUrl}/admin/categories/`, { params: params })
  }

  getById(id) {
    return axios.get(`${this.baseUrl}/admin/categories/?category_code=${id}`)
  }

  insert(params) {
    return axios.post(`${this.baseUrl}/admin/categories/insert/`, params)
  }

  update(id, params) {
    return axios.post(`${this.baseUrl}/admin/categories/update/${id}`, params)
  }

  changeSortOrder(params) {
    return axios.post(`${this.baseUrl}/admin/categories/sortorder/`, params)
  }

  delete(id) {
    return axios.post(`${this.baseUrl}/admin/categories/delete/${id}`)
  }
}
